import { connect } from 'react-redux';

import RetentionCustomSequencePicker from '../../../../../components/retention/complex/RetentionCustomSequencePicker';
import {
  calculateCustomSequence,
  changeCustomSequence,
  changeDimensionType,
  setCustomSequenceFrom,
  setCustomSequenceTo,
  setCustomSequenceType,
  toggleCustomSequence,
} from '../../../../../actions/dashboards/retentionComplex';
import {
  getDashboardsRetentionCustomSequenceDimensions,
  getDashboardsRetentionCustomSequence,
  getDashboardsRetentionCustomSequenceType,
  isDashboardsRetentionCustomSequenceEnabled,
  getDashboardsRetentionDimensionType,
} from '../../../../../reducers/analyticsApp';

const mapStateToProps = (state, { unitId }) => ({
  enabled: isDashboardsRetentionCustomSequenceEnabled(state, unitId),
  sequence: getDashboardsRetentionCustomSequence(state, unitId),
  sequenceType: getDashboardsRetentionCustomSequenceType(state, unitId),
  sequenceDimensions: getDashboardsRetentionCustomSequenceDimensions(state, unitId),
  dimensionType: getDashboardsRetentionDimensionType(state, unitId),
});

const mapDispatchToProps = (dispatch, { unitId }) => ({
  onToggle: () => dispatch(toggleCustomSequence(unitId)),
  onSequenceChange: (customSequence) => dispatch(changeCustomSequence(unitId, customSequence)),
  onSequenceTypeChange: (customSequenceType) =>
    dispatch(setCustomSequenceType(unitId, customSequenceType)),
  onSequenceFromChange: (from) => dispatch(setCustomSequenceFrom(unitId, from)),
  onSequenceToChange: (to) => dispatch(setCustomSequenceTo(unitId, to)),
  onCustomSequenceCalculate: () => dispatch(calculateCustomSequence(unitId)),
  onDimensionTypeChange: (dimensionType) => dispatch(changeDimensionType(unitId, dimensionType)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RetentionCustomSequencePicker);
